export class FrequencyControl {
  active: boolean = false;
  ratedFrequency: number = 50;
  maxFrequency: number = 80;
  motorSpeed: number = 1450;
  requiredGearI: number = 0;
  requiredGearN: number = 0;
  selectedGearI: number = 0;
  selectedGearN: number = 0;
}
